var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3-svgrepo-com 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2799 6.39981L11.7399 15.9398C10.7899 16.8898 7.96987 17.3298 7.33987 16.6998C6.70987 16.0698 7.13987 13.2498 8.08987 12.2998L17.6399 2.74978C17.8754 2.49284 18.1605 2.2863 18.4781 2.1426C18.7956 1.9989 19.139 1.921 19.4875 1.91366C19.8359 1.90633 20.1823 1.96967 20.5056 2.09988C20.8289 2.23009 21.1225 2.42449 21.3686 2.67129C21.6147 2.91809 21.8083 3.21219 21.9376 3.53585C22.0669 3.85952 22.1294 4.20602 22.1211 4.55447C22.1128 4.90292 22.0339 5.24611 21.8894 5.56326C21.7448 5.88041 21.5375 6.165 21.2799 6.39981Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13",
    stroke: "#304FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5307756c3a8f70f12ed53968e4ffbc3f.svg";
export { ForwardRef as ReactComponent };